import React, { useEffect, useState } from "react";
import ProgressCircle from "./CircularProgressChart";
import houseIcon from "../../assets/images/house-dashboard-water-float.png";
import ringIcon from "../../assets/images/ring-dashboard-water-float.png";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useTheme } from "../../utils/ThemeContext";
import FETCH from "../../utils/fetch";
import NewLoader from "../styled-components/loader/NewLoader";
import moment from "moment";

const DashboardSavingsGoal = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [goalsData, setGoalsData] = useState([]);

  const getGoalsList = async () => {
    try {
      setLoading(true);
      let response = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Goals&page=1&limit=100`,
        body: {},
      });
      if (response && response.records) {
        setGoalsData(response.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getGoalsList();
  }, []);
  const savingsGoals = [
    {
      id: 1,
      title: "Getting Married",
      icon: houseIcon,
      percentage: 42,
      amountNeeded: "$30,000.00",
      goalDate: "11-12-2029",
      savingPerMonth: "$278.00",
      amountSaved: "$13,640.29",
      onTrack: true,
    },
    {
      id: 2,
      title: "Retirement",
      icon: ringIcon,
      percentage: 75,
      amountNeeded: "$20,000.00",
      goalDate: "01-01-2028",
      savingPerMonth: "$320.00",
      amountSaved: "$15,000.00",
      onTrack: false,
    },
  ];
  function getMonthsDifference(date1, date2) {
    const year1 = date1.getFullYear();
    const year2 = date2.getFullYear();
    const month1 = date1.getMonth();
    const month2 = date2.getMonth();

    return (year2 - year1) * 12 + (month2 - month1);
  }
  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    return parseFloat(result).toFixed(2);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: theme === "dark" ? "#232323" : "white",
        display: "flex",
        alignItems: "center",
        overflowX: "scroll",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "start",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: "1rem 1rem 0 1rem" }}>
          <h3
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}
          >
            Goal Progress Max
          </h3>
        </div>
        <div
          style={{
            backgroundColor: theme === "dark" ? "#232323" : "white",
          }}
          className="goal-circle-tracker-container"
        >
          {goalsData &&
            goalsData.map((goal) => {
              let need = goal["Dollar Amount Needed"]
                ? calculateGoalNeed(
                    goal["Dollar Amount Needed"],
                    goal["Goal Date"] ? goal["Goal Date"] : new Date()
                  )
                : 0;
              let have = (
                (goal.assignAssets && Array.isArray(goal.assignAssets)
                  ? goal.assignAssets.reduce(
                      (acc, curr) =>
                        acc + parseFloat(curr.amountUseForGoal || 0),
                      0
                    )
                  : 0) +
                (goal["Amount Received"] &&
                Array.isArray(goal["Amount Received"])
                  ? goal["Amount Received"].reduce(
                      (acc, curr) => acc + parseFloat(curr || 0),
                      0
                    )
                  : 0)
              )
                .toFixed(2)
                .toString();
              let completionPercentage = (
                (parseFloat(have) / parseFloat(need)) *
                100
              ).toFixed(2);
              return (
                <div
                  key={goal.id}
                  style={{
                    backgroundColor: theme === "dark" ? "#2A3DA3" : "#E1EAFF",
                    flexDirection: "column",
                    display: "flex",
                    borderRadius: "12px",
                  }}
                >
                  <div
                    style={{
                      padding: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <img
                      style={{ height: "30px", width: "30px" }}
                      src={goal.image}
                      alt=""
                    />
                    <h3
                      style={{
                        color: theme === "dark" ? "#c4ceff" : "#343a40",
                      }}
                    >
                      {goal["Description of Goal"] || "N/A"}
                    </h3>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#c4ceff",
                      height: "0.5px",
                      margin: "0 16px",
                    }}
                  ></div>
                  <div className="goal-card">
                    <div className="circle-container">
                      <ProgressCircle
                        percentage={
                          completionPercentage >= 100
                            ? "100.00"
                            : completionPercentage
                        }
                      />
                    </div>
                    <div className="info-cards-container">
                      <p>
                        <strong
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#343a40",
                          }}
                        >
                          Amount Needed
                        </strong>{" "}
                        <br />{" "}
                        <span
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#2A3DA3",
                          }}
                        >
                          $
                          {(goal["Dollar Amount Needed"] &&
                            goal["Dollar Amount Needed"]
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")) ||
                            "N/A"}
                        </span>
                      </p>
                      <p>
                        <strong
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#343a40",
                          }}
                        >
                          Goal Date
                        </strong>{" "}
                        <br />{" "}
                        <span
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#2A3DA3",
                          }}
                        >
                          {goal["Goal Date"] &&
                            moment(goal["Goal Date"]).format("MM-DD-YYYY")}
                        </span>
                      </p>
                      <p>
                        <strong
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#343a40",
                          }}
                        >
                          $ Saving per Month
                        </strong>{" "}
                        <br />{" "}
                        <span
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#2A3DA3",
                          }}
                        >
                          {goal.savingPerMonth || "N/A"}
                        </span>
                      </p>
                      <p>
                        <strong
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#343a40",
                          }}
                        >
                          Amount Saved
                        </strong>{" "}
                        <br />{" "}
                        <span
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#2A3DA3",
                          }}
                        >
                          {goal.amountSaved || "N/A"}
                        </span>
                      </p>
                      <p>
                        <strong
                          style={{
                            color: theme === "dark" ? "#c4ceff" : "#343a40",
                          }}
                        >
                          On track for fully funded?
                        </strong>
                      </p>
                      <p style={{ color: goal.onTrack ? "green" : "red" }}>
                        {completionPercentage >= 100 ? (
                          <span>YES ✔️</span>
                        ) : (
                          <span>NO ❌</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* <div
        style={{
          marginRight: "1rem",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "#2A3DA3",
        }}
      >
        <p
          style={{
            margin: "0",
            whiteSpace: "nowrap",
            color: theme === "dark" ? "#c4ceff" : "#2A3DA3",
          }}
        >
          Show more
        </p>
        <ArrowRightOutlined />
      </div> */}
      <NewLoader isLoading={loading} />
    </div>
  );
};

export default DashboardSavingsGoal;
